// ============//frontend/src/Footer.js
import { Link } from 'react-router-dom'
import React from "react";
import MessageBuyToast from './components/MessageBuyToast';
function Footer() {

  return (
    // ========Start Footer
    <div>
      <footer className=''>
        {/* <div className="footer_jett pb-4">
          <div className="container-fluid mt-5">
            <div className='text1_footer'>Follow us</div>
            <div className='text2_footer'>CONNECT ONLINE</div>
            <div className="social mt-2 mb-3 text-center">
              <i className="jett_fa_footer fa fa-facebook fa-lg"></i>
              <i className="jett_fa_footer fa fa-instagram fa-lg"></i>
              <i className="jett_fa_footer fa fa-twitter fa-lg"></i>
              <i className="jett_fa_footer fa fa-linkedin fa-lg"></i>
              <i className="jett_fa_footer fa fa-youtube fa-lg"></i>

            </div>
          </div>
        </div> */}

        <div className='footer_jett2 py-4'>



          {/* ============ Message Buy =============== */}


          <div className="right-bottom-div mt-5">
            <MessageBuyToast />
          </div>
          {/* /* =========================== */}



          <center>


            <div className='jett_footer985 py-2 col-sm-8 d-none d-md-block'>
              <ul className="mb-2 mb-lg-0 jett_footer_menu">
                <li className="nav-item">
                  <Link className="menu_text text-white" to="/">HOME</Link>
                </li>
           
                <li className="nav-item">
                  <Link className="menu_text text-white" to="/Speaking">SPEAKING</Link>
                </li>
                <li className="nav-item">
                  <Link className="menu_text text-white" to="/Video">REVIEWS</Link>
                </li>
                {/* <li className="nav-item">
                  <Link className="menu_text text-white" to="/Press">PRESS KIT</Link>
                </li> */}
                <li className="nav-item">
                  <Link className="menu_text text-white" to="/Contact">CONTACT</Link>
                </li>
               
                <li className="nav-item">
                  <Link className="menu_text text-white" to="/GeneralTerms">TERMS OF USE</Link>
                </li>
              </ul>
            </div>
          </center>

	

          <div className='container d-flex align-items-center justify-content-center footer_jett_3098'>
            <div className='pt-5 col-sm-12'>
              <div className='row'>
                <div className='col-sm-5'>
                  <div className='text5_footer'>
                    <div className='text3_footer'>Persist, Persist, Persist.</div>
                    <div className='text4_footer'>The Haitian Boy, The American, and The Hidden Lesson</div>

                  </div>
                </div>


                {/* <div className='col-sm-7'>

                  <center>
                    <div className='footer_jett_flot54  mt-4'>
                      <a className="btn_login_jett px-2 " href="https://ayisyenkapab.com/persist-collection/" target='_blank'>SHOP</a>
                      <a className="btn_donate_jett px-2" href="/BuyDetails">PRE-ORDER NOW</a>
                    </div>
                  </center>
                </div> */}
              </div>
              <div className='bar_footer mt-3'></div>
              <div className='footer_jett78489 py-2 text-center opacity-50'>
                <i className="fa fa-copyright"></i> {new Date().getFullYear()}, PERSIST PERSIST PERSIST. All rights reserved.
              </div>

            </div>
          </div>




        </div>


      </footer>
    </div>
    // ========End Footer
  )
}

export default Footer